"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosSvcCustomerNotesSchema = exports.APosSvcRentalSchema = exports.APosSvcQueueEntrySchema = exports.APosSvcJobTicketSchema = exports.APosSvcTicketLineSchema = exports.APosSvcBookingSchema = exports.APosSvcBookingLineSchema = exports.APosSvcCustomerSnapshotSchema = exports.APosSvcResourceSchema = exports.APosSvcLocationSettingsSchema = exports.APosSvcStaffProfileSchema = exports.APosSvcServiceItemConfigSchema = exports.APosSvcRentalConfigSchema = exports.APosSvcIntakeQuestionSchema = exports.APosSvcReminderChannelSchema = exports.APosSvcResourceKindSchema = exports.APosSvcRentalUnitSchema = exports.APosSvcRentalStatusSchema = exports.APosSvcQueueStatusSchema = exports.APosSvcTicketPaymentStatusSchema = exports.APosSvcTicketStatusSchema = exports.APosSvcPaymentOptionSchema = exports.APosSvcDepositStatusSchema = exports.APosSvcBookingStatusSchema = exports.APosSvcDepositTypeSchema = exports.APosSvcModeSchema = exports.APosSvcItemKindSchema = exports.SVC_MAX_SPAN_WITH_RESOURCE = exports.SVC_MAX_SPAN_NO_RESOURCE = exports.SVC_LOCK_MINUTES = exports.SVC_PRODUCT_TYPE_RENTAL = exports.SVC_PRODUCT_TYPE_SERVICE = exports.SVC_FEATURES = void 0;
exports.defaultServicesLocationSettings = defaultServicesLocationSettings;
exports.applyServicePrepayment = applyServicePrepayment;
const zod_1 = require("zod");
const id_schema_1 = require("../../common/id.schema");
// ── Constants ──────────────────────────────────────────────────────────────
exports.SVC_FEATURES = {
    items: 'pos.services.items',
    tickets: 'pos.services.tickets',
    appointments: 'pos.services.appointments',
    checkin: 'pos.services.checkin',
    onlineBooking: 'pos.services.online-booking',
    reminders: 'pos.services.reminders',
    rentals: 'pos.services.rentals',
    button: 'pos.button.services',
};
exports.SVC_PRODUCT_TYPE_SERVICE = 'type_service';
exports.SVC_PRODUCT_TYPE_RENTAL = 'type_rental';
exports.SVC_LOCK_MINUTES = 5;
exports.SVC_MAX_SPAN_NO_RESOURCE = 480;
exports.SVC_MAX_SPAN_WITH_RESOURCE = 240;
const Iso = zod_1.z.string().min(20).max(40);
const LocalDate = zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
const MinuteOfDay = zod_1.z.number().int().min(0).max(1440);
const Money = zod_1.z.number().min(0).max(1000000);
const Id = zod_1.z.string().min(1).max(100);
const Step5 = (min, max) => zod_1.z.number().int().min(min).max(max).refine((n) => n % 5 === 0, 'must be a multiple of 5');
// ── Enums ──────────────────────────────────────────────────────────────────
exports.APosSvcItemKindSchema = zod_1.z.enum(['service', 'rental']);
exports.APosSvcModeSchema = zod_1.z.enum(['appointment', 'walkin', 'dropoff', 'till']);
exports.APosSvcDepositTypeSchema = zod_1.z.enum(['none', 'fixed', 'percent', 'full']);
exports.APosSvcBookingStatusSchema = zod_1.z.enum(['booked', 'checked_in', 'in_service', 'ready_for_checkout', 'completed', 'cancelled', 'no_show']);
exports.APosSvcDepositStatusSchema = zod_1.z.enum(['none', 'held', 'applied', 'refund_due', 'refunded', 'forfeit_pending', 'forfeited']);
exports.APosSvcPaymentOptionSchema = zod_1.z.enum(['deposit', 'full', 'in_store', 'none']);
exports.APosSvcTicketStatusSchema = zod_1.z.enum(['received', 'in_progress', 'ready', 'collected', 'cancelled']);
exports.APosSvcTicketPaymentStatusSchema = zod_1.z.enum(['unpaid', 'paid_pos', 'paid_online']);
exports.APosSvcQueueStatusSchema = zod_1.z.enum(['waiting', 'in_service', 'done', 'left']);
exports.APosSvcRentalStatusSchema = zod_1.z.enum(['reserved', 'out', 'returned', 'cancelled']);
exports.APosSvcRentalUnitSchema = zod_1.z.enum(['hour', 'day', 'weekend']);
exports.APosSvcResourceKindSchema = zod_1.z.enum(['chair', 'room', 'station', 'asset']);
exports.APosSvcReminderChannelSchema = zod_1.z.enum(['email', 'sms', 'off']);
// ── Service item config ────────────────────────────────────────────────────
exports.APosSvcIntakeQuestionSchema = zod_1.z.object({
    id: zod_1.z.string().min(1).max(40),
    label: zod_1.z.string().min(1).max(200),
    type: zod_1.z.enum(['yesno', 'text']),
    required: zod_1.z.boolean().default(false),
});
exports.APosSvcRentalConfigSchema = zod_1.z.object({
    unit: exports.APosSvcRentalUnitSchema,
    lateFeePerUnit: Money.default(0),
    graceMin: zod_1.z.number().int().min(0).max(1440).default(0),
    depositAmount: Money.default(0),
});
exports.APosSvcServiceItemConfigSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    productId: Id,
    kind: exports.APosSvcItemKindSchema,
    durationMin: Step5(5, 480),
    bufferMin: Step5(0, 120).default(0),
    modes: zod_1.z.array(exports.APosSvcModeSchema).min(1),
    customerRequired: zod_1.z.boolean().default(false),
    bookableOnline: zod_1.z.boolean().default(false),
    depositType: exports.APosSvcDepositTypeSchema.default('none'),
    depositValue: Money.default(0),
    staffIds: zod_1.z.array(Id).default([]),
    staffOverrides: zod_1.z.record(zod_1.z.object({ price: Money.optional(), durationMin: Step5(5, 480).optional() })).default({}),
    resourceKind: exports.APosSvcResourceKindSchema.optional(),
    intakeQuestions: zod_1.z.array(exports.APosSvcIntakeQuestionSchema).max(10).default([]),
    rental: exports.APosSvcRentalConfigSchema.optional(),
    updatedAt: Iso,
}).superRefine((v, ctx) => {
    if (v.kind === 'rental' && !v.rental)
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, message: 'rental config is required for rental items', path: ['rental'] });
    if (v.depositType === 'percent' && v.depositValue > 100)
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, message: 'percent deposit must be <= 100', path: ['depositValue'] });
});
// ── Staff profile ──────────────────────────────────────────────────────────
exports.APosSvcStaffProfileSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    employeeId: Id,
    displayName: zod_1.z.string().min(1).max(80),
    locationIds: zod_1.z.array(Id).default([]),
    bookable: zod_1.z.boolean().default(true),
    availabilitySource: zod_1.z.enum(['shifts', 'business_hours']).default('shifts'),
    color: zod_1.z.string().max(20).optional(),
    updatedAt: Iso,
});
// ── Location settings ──────────────────────────────────────────────────────
const DayHours = zod_1.z.object({ open: zod_1.z.boolean(), startMin: MinuteOfDay, endMin: MinuteOfDay });
const ReminderSlot = zod_1.z.object({ channel: exports.APosSvcReminderChannelSchema, hoursBefore: zod_1.z.number().int().min(1).max(168) });
exports.APosSvcLocationSettingsSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    locationId: Id,
    displayName: zod_1.z.string().min(1).max(120),
    timezone: zod_1.z.string().min(1).max(50),
    publicBaseUrl: zod_1.z.string().max(300).default(''),
    businessHours: zod_1.z.object({ '0': DayHours, '1': DayHours, '2': DayHours, '3': DayHours, '4': DayHours, '5': DayHours, '6': DayHours }),
    slotIntervalMin: zod_1.z.union([zod_1.z.literal(5), zod_1.z.literal(10), zod_1.z.literal(15), zod_1.z.literal(30), zod_1.z.literal(60)]),
    minLeadMin: zod_1.z.number().int().min(0).max(10080),
    maxAdvanceDays: zod_1.z.number().int().min(1).max(365),
    customerPicksStaff: zod_1.z.boolean(),
    onlineBookingEnabled: zod_1.z.boolean(),
    defaultPaymentOption: zod_1.z.enum(['deposit', 'full', 'in_store']),
    allowPayInStore: zod_1.z.boolean(),
    freeCancelHours: zod_1.z.number().int().min(0).max(168),
    lateCancelPolicy: zod_1.z.enum(['keep_prepaid', 'refund']),
    noShowPolicy: zod_1.z.enum(['keep_prepaid', 'refund']),
    checkinLinkEnabled: zod_1.z.boolean(),
    counterQrEnabled: zod_1.z.boolean(),
    walkinQueueEnabled: zod_1.z.boolean(),
    queueRequiresProfile: zod_1.z.boolean(),
    showWaitOnline: zod_1.z.boolean(),
    reminders: zod_1.z.object({
        confirmationEmail: zod_1.z.boolean(),
        reminder1: ReminderSlot,
        reminder2: ReminderSlot,
        copyAdmin: zod_1.z.boolean(),
        notifyEmail: zod_1.z.string().max(200).default(''),
    }),
    tickets: zod_1.z.object({
        prefix: zod_1.z.string().min(1).max(4),
        printClaimTag: zod_1.z.boolean(),
        notifyWhenReady: zod_1.z.boolean(),
        pickupReminderDays: zod_1.z.array(zod_1.z.number().int().min(1).max(365)).max(5),
        unclaimedAfterDays: zod_1.z.number().int().min(1).max(730),
    }),
    updatedAt: Iso,
}).superRefine((v, ctx) => {
    for (const d of ['0', '1', '2', '3', '4', '5', '6']) {
        const h = v.businessHours[d];
        if (h.open && h.startMin >= h.endMin)
            ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, message: `day ${d}: open must be before close`, path: ['businessHours', d] });
    }
    if (v.onlineBookingEnabled && !/^https:\/\//.test(v.publicBaseUrl))
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, message: 'publicBaseUrl (https://…) is required when online booking is on', path: ['publicBaseUrl'] });
});
function defaultServicesLocationSettings(tenantId, locationId, timezone, displayName) {
    const open = { open: true, startMin: 540, endMin: 1080 };
    return {
        tenantId, locationId, displayName, timezone, publicBaseUrl: '',
        businessHours: { '0': { open: false, startMin: 540, endMin: 1080 }, '1': open, '2': open, '3': open, '4': open, '5': open, '6': open },
        slotIntervalMin: 15, minLeadMin: 120, maxAdvanceDays: 60, customerPicksStaff: true,
        onlineBookingEnabled: false, defaultPaymentOption: 'deposit', allowPayInStore: true,
        freeCancelHours: 24, lateCancelPolicy: 'keep_prepaid', noShowPolicy: 'keep_prepaid',
        checkinLinkEnabled: true, counterQrEnabled: false, walkinQueueEnabled: true, queueRequiresProfile: false, showWaitOnline: true,
        reminders: { confirmationEmail: true, reminder1: { channel: 'email', hoursBefore: 24 }, reminder2: { channel: 'off', hoursBefore: 2 }, copyAdmin: false, notifyEmail: '' },
        tickets: { prefix: 'T-', printClaimTag: true, notifyWhenReady: true, pickupReminderDays: [7, 14, 30], unclaimedAfterDays: 90 },
        updatedAt: new Date().toISOString(),
    };
}
// ── Resources ──────────────────────────────────────────────────────────────
exports.APosSvcResourceSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    resourceId: Id,
    locationId: Id,
    kind: exports.APosSvcResourceKindSchema,
    name: zod_1.z.string().min(1).max(80),
    active: zod_1.z.boolean().default(true),
    rentalProductId: Id.optional(),
    updatedAt: Iso,
});
// ── Shared snapshots ───────────────────────────────────────────────────────
exports.APosSvcCustomerSnapshotSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(120),
    phone: zod_1.z.string().min(1).max(30),
    email: zod_1.z.string().max(200).optional(),
});
// ── Bookings ───────────────────────────────────────────────────────────────
exports.APosSvcBookingLineSchema = zod_1.z.object({
    productId: Id,
    variantId: Id.optional(),
    name: zod_1.z.string().min(1).max(200),
    unitPrice: Money,
    durationMin: Step5(5, 480),
    bufferMin: Step5(0, 120).default(0),
});
exports.APosSvcBookingSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    bookingId: Id,
    locationId: Id,
    date: LocalDate,
    startMin: MinuteOfDay,
    endMin: MinuteOfDay,
    startAt: Iso,
    endAt: Iso,
    staffId: Id,
    resourceId: Id.optional(),
    customerId: Id,
    customer: exports.APosSvcCustomerSnapshotSchema,
    lines: zod_1.z.array(exports.APosSvcBookingLineSchema).min(1).max(10),
    intakeAnswers: zod_1.z.record(zod_1.z.string().max(500)).default({}),
    notes: zod_1.z.string().max(1000).optional(),
    source: zod_1.z.enum(['online', 'backoffice', 'pos']),
    status: exports.APosSvcBookingStatusSchema,
    paymentOption: exports.APosSvcPaymentOptionSchema,
    prepaidAmount: Money,
    prepaidRef: zod_1.z.string().max(200).optional(),
    depositStatus: exports.APosSvcDepositStatusSchema,
    refundDueAmount: Money.optional(),
    saleRef: zod_1.z.string().max(200).optional(),
    publicToken: zod_1.z.string().length(32),
    checkedInAt: Iso.optional(),
    startedAt: Iso.optional(),
    completedAt: Iso.optional(),
    cancelledAt: Iso.optional(),
    cancelReason: zod_1.z.string().max(300).optional(),
    remindersSent: zod_1.z.array(zod_1.z.string()).default([]),
    nextReminderAt: Iso.optional(),
    reminderShard: zod_1.z.literal('due').optional(),
    createdAt: Iso,
    updatedAt: Iso,
}).refine((b) => b.startMin < b.endMin, { message: 'startMin must be before endMin', path: ['endMin'] });
// ── Job tickets ────────────────────────────────────────────────────────────
exports.APosSvcTicketLineSchema = zod_1.z.object({
    productId: Id,
    variantId: Id.optional(),
    name: zod_1.z.string().min(1).max(200),
    unitPrice: Money,
    qty: zod_1.z.number().int().min(1).max(999),
});
exports.APosSvcJobTicketSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    ticketId: Id,
    ticketNumber: zod_1.z.string().min(2).max(20),
    locationId: Id,
    customerId: Id,
    customer: exports.APosSvcCustomerSnapshotSchema,
    lines: zod_1.z.array(exports.APosSvcTicketLineSchema).min(1).max(30),
    intakeNotes: zod_1.z.string().max(1000).default(''),
    readyBy: Iso,
    status: exports.APosSvcTicketStatusSchema,
    assignedStaffId: Id.optional(),
    paymentStatus: exports.APosSvcTicketPaymentStatusSchema,
    paidAmount: Money,
    saleRef: zod_1.z.string().max(200).optional(),
    prepaidRef: zod_1.z.string().max(200).optional(),
    /** Online payment still held after the ticket was cancelled or paid twice — cleared by `mark_refunded`. Additive. */
    refundDueAmount: Money.optional(),
    notifyWhenReady: zod_1.z.boolean(),
    publicToken: zod_1.z.string().length(32),
    readyAt: Iso.optional(),
    collectedAt: Iso.optional(),
    pickupRemindersSent: zod_1.z.array(zod_1.z.number().int()).default([]),
    nextReminderAt: Iso.optional(),
    reminderShard: zod_1.z.literal('due').optional(),
    createdAt: Iso,
    updatedAt: Iso,
});
// ── Queue ──────────────────────────────────────────────────────────────────
exports.APosSvcQueueEntrySchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    entryId: Id,
    locationId: Id,
    date: LocalDate,
    number: zod_1.z.number().int().min(1),
    customerId: Id.optional(),
    name: zod_1.z.string().min(1).max(120),
    phone: zod_1.z.string().max(30).optional(),
    productId: Id.optional(),
    serviceName: zod_1.z.string().max(200).default('Walk-in'),
    durationMin: zod_1.z.number().int().min(0).max(480).default(30),
    bookingId: Id.optional(),
    source: zod_1.z.enum(['walkin_pos', 'walkin_online', 'booking']),
    status: exports.APosSvcQueueStatusSchema,
    staffId: Id.optional(),
    joinedAt: Iso,
    startedAt: Iso.optional(),
    endedAt: Iso.optional(),
    ttl: zod_1.z.number().int().optional(),
});
// ── Rentals ────────────────────────────────────────────────────────────────
exports.APosSvcRentalSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    rentalId: Id,
    locationId: Id,
    assetId: Id,
    assetName: zod_1.z.string().min(1).max(80),
    productId: Id,
    customerId: Id,
    customer: exports.APosSvcCustomerSnapshotSchema,
    startAt: Iso,
    dueAt: Iso,
    units: zod_1.z.number().int().min(1).max(1000),
    unit: exports.APosSvcRentalUnitSchema,
    unitPrice: Money,
    status: exports.APosSvcRentalStatusSchema,
    deposit: zod_1.z.object({ amount: Money, method: zod_1.z.enum(['cash', 'card', 'id_held', 'none']), status: zod_1.z.enum(['held', 'returned', 'kept']) }),
    lateFee: zod_1.z.object({ units: zod_1.z.number().int().min(0), amount: Money, accepted: zod_1.z.boolean() }).optional(),
    saleRef: zod_1.z.string().max(200).optional(),
    returnSaleRef: zod_1.z.string().max(200).optional(),
    returnedAt: Iso.optional(),
    createdAt: Iso,
    updatedAt: Iso,
});
// ── Customer notes (staff-only) ────────────────────────────────────────────
exports.APosSvcCustomerNotesSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    customerId: Id,
    notes: zod_1.z.string().max(2000).default(''),
    preferredStaffId: Id.optional(),
    reminderChannel: zod_1.z.enum(['email', 'sms', 'both']).default('email'),
    updatedBy: zod_1.z.string().max(200).default(''),
    updatedAt: Iso,
});
// ── Prepayment math shared by POS checkout and the backend (one source of truth) ──
function applyServicePrepayment(grandTotal, prepaid) {
    const r2 = (n) => Math.round(n * 100) / 100;
    const total = Math.max(0, grandTotal);
    const paid = Math.max(0, prepaid);
    const applied = r2(Math.min(paid, total));
    return { applied, due: r2(total - applied), refundDue: r2(paid - applied) };
}
//# sourceMappingURL=services.schema.js.map